import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AirportProperties } from '../Models/AirportProperties';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class AirportService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.baseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

  GetAllAirport(): Observable<AirportProperties[]> {
    return this.http.get<AirportProperties[]>(this.baseUrl + '/Airport/AirportGetAll').pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }

  CreateAirportsData(newobj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Airport/CreateAirportData', newobj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateAirportDetails(userObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Airport/UpdateAirportDetail', userObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  DeleteAirportDetails(userObj, userid): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Airport/DeleteAirport/' + userObj + '/' + userid, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
}
